<template>
  <div class="omikuji contentArea">
    <div class="inner">
      <div class="inputBox">
          <p class="balloonText">今年の<br>運勢は…</p>
          <UnseiImages :unsei="unsei"/>
      </div>
      <div class="unseiDlBox">
          <div class="unseiDlDesc"><img src="@/assets/img-tweet0.png" alt="絵馬つきツイートをしよう"></div>
          <div class="unseiDlBtn" @click="download"><img class="btn" src="@/assets/btn04.png" alt="絵馬をダウンロードする"></div>
          <UnseiImages :unsei="unsei"/>
      </div>

      <div class="unseiTweetBox">
          <div class="unseiTweetDesc"><img src="@/assets/img-tweet2.png" alt="絵馬つきツイートをしよう"></div>
          <div class="unseiTweetBtn" @click="tweet('')"><img src="@/assets/btn03.png" alt="ツイートする"></div>
      </div>
    </div>
  </div>
</template>

<script>
import parser from 'ua-parser-js'
import { saveAs } from 'file-saver'

import UnseiImages from '@/components/UnseiImages.vue'

export default {
  data() {
    return {
      unsei: "daikichi",
      tweetHash: "#謹賀新年 #Kidsplates"
    }
  },
  created() {
    this.makeUnsei();
  },
  methods: {
    makeUnsei: function() {
      const rand = Math.floor( Math.random() * 100)
      this.unsei = "daikichi"
      if (rand < 50) this.unsei = "chukichi"
      if (rand < 30) this.unsei = "kichi"
      if (rand < 10) this.unsei = "kyou"
    },
    download: function() {
      const os = parser().os.name;
      if (os == 'iOS') { return; }

      // 画像を取ります
      const img = document.querySelector('.unseiImg img');

      // 同じサイズの <canvas> を作ります
      const canvas = document.createElement('canvas');
      canvas.width = 601;
      canvas.height = 475;

      const context = canvas.getContext('2d');

      // 画像をコピーします (このメソッドで画像をカットすることができます)
      context.drawImage(img, 0, 0);
      // canvas 上では、context.rotate(), やその他様々なことができます

      // toBlob は非同期操作で、callback は完了時に呼ばれます
      canvas.toBlob(function(blob) {
      // blob の準備ができたのでダウンロードします

          saveAs(blob, "unsei.png");
      }, 'image/png');
    },
    tweet: function(text) {
        const url = 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(text+"\n"+this.tweetHash);
        const isWindowOpen = window.open(url, '_blank');
        if( isWindowOpen == null ) {
            location.href = url;
        }
    }
  },
  components: {
    UnseiImages
  }
}
</script>

<style scoped lang="scss">
.omikuji {
  background: #581033 url("../assets/bg-jinja-ebi.png") no-repeat top center;
  overflow-y: scroll;
  .inner {
    background: #581033 url("../assets/bg-jinja-ebi.png") no-repeat top center;
    background-size: 100%;
    padding: 1px 0;
    margin: -1px 0;
    min-height: 100%;
  }
  .balloonText {
      position: absolute;
      left: 0;
      bottom: 79%;
      width: 51%;
      height: 68%;
      padding: 17% 0 0 0;
      box-sizing: border-box;
      background: url("../assets/balloon.png") no-repeat top center;
      background-size: contain;
      font-size: 6vw;
      font-weight: bold;
      text-align: center;
  }
  .inputBox {
      position: relative;
      margin: 30vh 3% 0;
  }
  .inputBox-inner {
      position: absolute;
      top: 0;
      left: 5%;
      width: 90%;
      height: 100%;
      padding: 32% 0 12%;
      box-sizing: border-box;
  }
  .unseiDlBox {
      position: relative;
      margin: 10% 3% 0;
    .unseiImg {
        position: absolute;
        top: 55%;
        left: 21%;
        width: 58%;
    }
  }
  .unseiDlBtn {
      position: absolute;
      top: 15%;
      left: 25%;
      text-align: center;
      width: 50%;
  }

  .unseiTweetBox {
      position: relative;
      color: #edb88e;
      font-size: 4vw;
      margin: 3% 3% 10%;
      border-radius: 10px;
  }
  .unseiTweetBtn {
      position: absolute;
      top: 0;
      margin: 47% 25% 0;
      text-align: center;
      width: 50%;
  }
}
</style>
